import React from 'react';
import CountUp from 'react-countup';
import { Col, Row } from 'reactstrap';

const Counter2 = () => {
    return (
        <Row className="text-center">
            <Col lg="6" md="6">
                <div className="counter bg-primary rounded p-5 shadow">
                    <div className="counter-desc text-white">
                        <h5>Happy Clients</h5>
                        <CountUp className="count-number display-4" end={21} duration={30} />
                        <span className="display-4"></span>
                    </div>
                </div>
            </Col>
            <Col lg="6" md="6" className="mt-5">
                <div className="counter bg-white rounded p-5 shadow">
                    <div className="counter-desc">
                        <h5>Customer Satisfaction</h5>
                        <CountUp className="count-number display-4 text-primary" end={98} duration={30} />
                        <span className="display-4 text-primary">%</span>
                    </div>
                </div>
            </Col>
            <Col lg="6" md="6" className="mt-5 mt-md-0">
                <div className="counter bg-white rounded p-5 shadow">
                    <div className="counter-desc">
                        <h5>Cost Reduction</h5>
                        <CountUp className="count-number display-4 text-primary" end={63} duration={30} />
                        <span className="display-4 text-primary">%</span>
                    </div>
                </div>
            </Col>
            <Col lg="6" md="6" className="mt-5">
                <div className="counter bg-orange rounded p-5 shadow">
                    <div className="counter-desc text-white">
                        <h5>Service Quality</h5>
                        <CountUp className="count-number display-4" end={99} duration={30} />
                        <span className="display-4">%</span>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default Counter2;